module.exports = __webpack_public_path__ + "img/about3.ffd61948.png";